import * as React from "react";
import { ContentError } from "./ContentError";

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

/**
 * Catches render errors in its subtree and shows the crash fallback instead of
 * a blank screen. Used at the app root and around the 3D <Canvas> so a WebGL/
 * scene crash can't take the whole site down. Retry reloads the page.
 */
export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Frontend logging only — no external error reporting.
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ContentError variant="crash" onRetry={() => window.location.reload()} />
      );
    }
    return this.props.children;
  }
}
